import * as React from 'react';
import { TooltipProvider, ToastProvider } from '@viewstream/ui';
import { LocaleProvider, pickInitialLocale } from './locale';
import { AuthProvider } from './auth';
import { startVitals } from './telemetry';

/** Shared by Studio and Admin (apps/admin imports this): providers that do not depend on the router. */
export function bootstrap() {
  startVitals();
  const initial = pickInitialLocale();
  function Providers({ children }: { children: React.ReactNode }) {
    return (
      <LocaleProvider initial={initial}>
        <TooltipProvider>
          <ToastProvider closeLabel="×">
            <AuthProvider>{children}</AuthProvider>
          </ToastProvider>
        </TooltipProvider>
      </LocaleProvider>
    );
  }
  return { Providers };
}
